import React from 'react';

const runtime = typeof document === 'object';

const googleVisitedPixel = `
  if(window.gtag){
    window.gtag('event', 'conversion', {'send_to': 'AW-821881030/TycKCMO30JgZEMbR84cD'});
  }
`;

let opts;

class Script extends React.Component {
  componentDidMount() {
    if (runtime) {
      [googleVisitedPixel].forEach(() => {
        if (opts.googleVisitedPixel && window.gtag) {
          const googleScript = document.createElement('script');
          googleScript.innerHTML = googleVisitedPixel;
          document.body.appendChild(googleScript);
        }
      });
    }
  }

  render() {
    return null;
  }
}

function PixelScript(data) {
  opts = data;

  return <Script />;
}

export default PixelScript;
